if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');

        document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));

        const button = this.querySelector('button');
        if (button)
          button.addEventListener('click', (evt) => {
            document.querySelector('pickup-availability-drawer').show(evt.target);
          });
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('button').addEventListener('click', () => {
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest('pickup-availability-drawer') &&
          target.id != 'ShowPickupAvailabilityDrawer'
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        trapFocus(this);
        sortLocations(); //DBG added
        toggleShowAvailable(); //DBG added
      }
    }
  );
}

/* DBG Added */
function sortLocations(){
  const selectedLocation = localStorage.getItem("selectedStore");
  const pickupList = document.querySelector('pickup-availability-drawer > ul.pickup-availability-list');
  const elements = pickupList.querySelectorAll('li');  
  
  let myState = "SA"; // default to SA if the user hasn't been here before
  // if the user's selected store is in the list pick up the state and use it in the second for loop to sort their state to the top
  for (var i=0; i<elements.length; i++) {
    const store = elements[i].querySelector('h3');
    if (!store) {
        continue;
    }
    let storeName = store.textContent;
    if(storeName===selectedLocation) {      
      myState = elements[i].querySelector('.province_code').textContent;
    }
  }
  
  var sortMe = [];
  for (var i=0; i<elements.length; i++) {
    const store = elements[i].querySelector('h3');
    if (!store) {
        continue;
    }
    let storeName = store.textContent;
    let state = elements[i].querySelector('.province_code').textContent;
    if(state===myState)
      state = '.' + state; //. will be first alphabetically
    if(storeName === selectedLocation)
      state = '.' + state; //. will be first first alphabetically
    sortMe.push([state, storeName, elements[i]]);
  }
  sortMe.sort();

  for (var i=0; i<sortMe.length; i++) {
    pickupList.appendChild(sortMe[i][2]);
    if(sortMe[i][2].classList.contains('more-location') && i < 10)
      sortMe[i][2].classList.remove('more-location')
    if(!sortMe[i][2].classList.contains('more-location') && i >= 10)
      sortMe[i][2].classList.add('more-location')
  }
}

function toggleShowAvailable() {
  const showAvailable = document.querySelector('#storesstock');
  if(showAvailable) {
    if (showAvailable.checked) {
      // hide all stores with no availability
      document.querySelector('#show-more-stores').click();
      document.querySelectorAll('.unavailable').forEach((e)=>{e.classList.add('visually-hidden')});      
    } else {
      document.querySelectorAll('.unavailable').forEach((e)=>{e.classList.remove('visually-hidden')})
    }
  }
}